import { Button, IconButton, Link, useMediaQuery, useTheme } from "@mui/material";

import { useTranslate } from "src/locales";

import Iconify from "src/components/iconify";
import { RouterLink } from "src/routes/components";
import { paths } from "src/routes/paths";

const RETURN_KEY = 'kb_return_to';

const rememberReturnLocation = () => {
  try {
    const here = window.location.pathname + window.location.search;
    if (!here.startsWith('/help')) {
      sessionStorage.setItem(RETURN_KEY, here);
    }
  } catch {
    // sessionStorage unavailable; the close button will fall back to dashboard
  }
};

export const KnowledgeBaseButton = () => {

  const { t } = useTranslate();

  const theme = useTheme();

  const isNotLargeDevice = useMediaQuery(theme.breakpoints.down('md'));

  if (isNotLargeDevice) {
    return (
      <Link
        component={RouterLink}
        href={paths.help.root}
        onClick={rememberReturnLocation}
        underline="none"
      >
        <IconButton
          color="primary"
        >
          <Iconify icon="solar:documents-line-duotone" />
        </IconButton>
      </Link>
    );
  }

  return (
    <Link
      component={RouterLink}
      href={paths.help.root}
      onClick={rememberReturnLocation}
      underline="none"
    >
      <Button
        variant="outlined"
        color="primary"
        startIcon={<Iconify icon="solar:documents-line-duotone" />}
      >
        {t('common.help')}
      </Button>
    </Link>
  );
}
